/**
 * Minimal shapes of the roleplay backend's `v2/role-play/user/info`
 * response — only the fields the main app reads. The full contract lives
 * in the flymsg-roleplay repo (src/app/dto/role-play-subscription.model.ts
 * and add-ons.model.ts); keep field names in sync with it.
 */

export interface RoleplayAddOn {
  id: string;
  name: string;
  identifier: string;
  description?: string;
  price: number;
  recurrency_type: "monthly" | "yearly" | "one-time";
}

export interface RoleplayUserInfo {
  add_on: RoleplayAddOn | null;
}

/**
 * `v2/role-play/*` endpoints nest their payload one level deeper than the
 * standard envelope: `{ result: { status, data: <payload> } }`. The
 * roleplay app's ApiService unwraps `response.result.data` for every call.
 */
export interface RoleplayApiResult<T> {
  status?: string;
  data?: T;
}

/**
 * Mirrors the roleplay app's free-plan test (its AuthService.isFreePlan,
 * inverted) so both apps agree on what counts as a paid RolePlay
 * subscription.
 */
export function isPaidRoleplayAddOn(addOn: RoleplayAddOn | null | undefined): addOn is RoleplayAddOn {
  if (!addOn) {
    return false;
  }
  return (
    addOn.price > 0 &&
    !addOn.identifier?.includes("free") &&
    !addOn.identifier?.includes("beginner")
  );
}
